import React from "react";
import PulseMobileCarousel from "@features/pulse/components/PulseMobileCarousel/PulseMobileCarousel";
import { PulsePageProps } from "@features/pulse/utils/types";

export default function PulseMobilePage({
  sortedPulseData,
  currentSlide,
  currentSlideId,
  setCurrentSlide,
  setCurrentSlideId,
  backToBt = "/",
}: PulsePageProps): React.ReactElement {
  if (sortedPulseData.length === 0) return <></>;

  return (
    <div
      data-testid="pulse-mobile-page"
      className="block h-full w-full lg:hidden"
    >
      <PulseMobileCarousel
        sortedPulseData={sortedPulseData}
        currentSlide={currentSlide}
        currentSlideId={currentSlideId || ""}
        setCurrentSlide={setCurrentSlide}
        setCurrentSlideId={setCurrentSlideId}
        backToBt={backToBt}
      />
    </div>
  );
}
